import { CookieClass } from '../../class/cookie.class'
import { TOPUP_COOKIE_NAME, TOPUP_COOKIE_TEXT } from '../../const/topup.const'

export default {
  data () {
    return {
      TOPUP_COOKIE_TEXT: TOPUP_COOKIE_TEXT
    }
  },
  methods: {
    isCookieFlagSet: () => {
      return !!CookieClass.getCookie(TOPUP_COOKIE_NAME)
    },
    setCookieFlag () {
      CookieClass.setCookie(TOPUP_COOKIE_NAME, 1)
      this.$forceUpdate()
    }
  }
}
